<template>
  <div class="page">
    <my-header :breadcrumb="breadcrumb"></my-header>
    <div class="content">
      <div class="content-wrap">
        <!--搜索-->
        <el-button type="primary" @click="clickAdd">添加广告位</el-button>
        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
          <el-form :model="form">
            <el-form-item label="广告位名称" :label-width="formLabelWidth">
              <el-input v-model="form.position_name"></el-input>
            </el-form-item>


          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="clickConfirm">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 工具栏（列表名称、列表显示项设置） -->
        <!--列表内容-->

        <el-table
          :data="tableData"
          style="width: 100%;margin:10px 0 0 0;"
          row-key="cate_id"
          default-expand-all
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          :default-sort="{prop: 'nav_id', order: 'ascending'}"
        >

          <el-table-column
            prop="position_name"
            label="广告位名称"
            sortable
            >
          </el-table-column>


          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)">编辑
              </el-button>
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalCount" :page-size="10" class="page-wrap">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import MyHeader from "../header";
  import Cookies from "js-cookie"
  export default {
    name: "position-list",
    components: {
      MyHeader
    },
    data() {
      return {
        form: {
          parentName:'',
          typeName:'',
          moduleName:''
        },
        formLabelWidth:'120px',
        tableData: [],
        totalCount: 0,
        pageCount: 1,
        breadcrumb: [
          {
            name: '网站导航'
          },
          {
            name: '导航列表'
          }
        ],
        dialogFormVisible:false,
        arrType:[
          {label:'内部模块',value:1},
          {label:'外部链接',value:2}
        ],
        arrModule:[
          {label:'文章模块',value:1}
        ],
        showModule:false,
        showLink:false,
        dialogTitle:'添加广告位',
        categoryList:[],
        parentList:[]
      }
    },
    created(){
      this.form.nav_id = this.$route.query.id;
      this.$http.get(this.apiUrl+'/v1/ad-position/index',{params:{site_id:Cookies.get('siteId')}}).then(({data})=>{
        this.tableData = data;
      })
    },
    methods:{
      clickAdd(){
        this.dialogFormVisible = true;
      },
      clickConfirm(){
        this.form.site_id = Cookies.get('siteId')
        this.$http.post('/v1/ad-position/save',this.form).then(({data})=>{
          if (data.errcode == 0){
            this.$message.success(data.msg);
            this.dialogFormVisible = false;
            this.$http.get(this.apiUrl+'/v1/ad-position/index',{params:{site_id:Cookies.get('siteId')}}).then(({data})=>{
              this.tableData = data;
            })
          }else{
            this.$message.error(data.msg);
          }
        })
      },
      handleEdit(index,row){
        var _this = this;
        this.dialogFormVisible = true;
        this.dialogTitle = '修改广告位';
        this.$http.get('/v1/ad-position/view?id='+row.position_id).then(({data})=>{
          this.form = data.result;
        })
      },
      handleDelete(index,row){
        this.$http.delete('/v1/ad-position/delete?id='+row.position_id).then(({data})=>{
          if (data.errcode == 0){
            this.$message.success(data.msg);
            this.$http.get('/v1/ad-position/index',{params:{site_id:Cookies.get('siteId')}}).then(({data})=>{
              this.tableData = data;
            })
          }else{
            this.$message.error(data.msg)
          }
        })
      },
      changeType(val){
        this.form.type = val;
        if (val == 1){
          this.showModule = true;
          this.showLink = false;

        }else {
          this.showLink = true;
          this.showModule = false;
          this.form.module_id = 0;
        }
      },
      changeModule(val){
        this.form.module_id = val;
        if (val == 1){
          this.$http.get('/v1/acategory/list?siteId='+Cookies.get('siteId')).then(({data}) => {
            this.categoryList = data.result;
          })
        }

      },
      changeCate(val){
        var _this = this;
        this.form.category_id = val;
        if (!this.form.nav_id){
          this.categoryList.forEach(function (item) {
            if(item.cate_id == val){
              _this.form.title =  item.cate_name;
            }
          })
        }

      },
      changeParent(val){
        var _this = this;
        this.form.parent_id  = val;
        this.tableData.forEach(function (item) {
          if (item.cate_id == val){
            _this.form.parentName = item.cate_name;
          }
        })
      }
    }
  }
</script>

<style scoped>
  .page-wrap{
    float: right;
    margin:30px 0 0 0;
  }
</style>
